import { setErrorReporter } from 'jcsdk';

/** The single seam for an error backend (e.g. Sentry); logs for now. Call once before render. */
export const installJCalErrorReporter = (): void => {
    setErrorReporter((error, context) => {
        console.error('[jcallard]', error, context ?? {});
    });
};
